import styled from 'styled-components';

import { beam } from '@styles/colors/themes';

export const Container = styled.div`
  position: relative;
  padding: 12px 16px 24px 16px;
  z-index: 10;
`;

export const Header = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;

  margin-bottom: 16px;
`;

export const Title = styled.div`
  color: #161a30;
  font-size: 16px;
  font-weight: 600;
`;

export const Close = styled.button`
  width: 32px;
  height: 32px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;

  cursor: pointer;
  border: 0;
  background-color: transparent;

  transition: 0.2s;

  @media (hover: hover) {
    :hover {
      background-color: var(--beam-color-neutral-n100);
    }
  }
`;

export const Label = styled.h2`
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  margin-bottom: 0;
  color: #161a30;

  &.block {
    color: #ea1212;
  }
`;

export const Content = styled.h2`
  color: ${beam.font.primary};
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 16px;
`;

export const Icon = styled.img`
  display: flex;
  flex-direction: column;
  margin-right: 8px;
`;

interface ItemProps {
  isDisabled?: boolean;
}

export const Item = styled.div<ItemProps>`
  display: flex;
  height: 38px;
  padding: 8px;
  border-radius: 8px;
  cursor: pointer;
  align-items: center;
  justify-content: flex-start;
  position: relative;
  color: ${beam.font.primary};

  column-gap: 8px;
  transition: 0.2s;

  :hover {
    background-color: #f6f8ff;
  }
`;

export const Block = styled.div`
  background: #fff;
  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.161);
  border-radius: 8px;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 999;
  cursor: auto;
`;
